import { Link, useNavigate } from "react-router-dom";

const SplitedOrders = ({
  orders,
  selectedItems,
  handleButtonClick,
  genrateInvoiceModal,
  selectItems,
  location,
  handleDeliverButton,
  setOpenMarkedGenerated,
}) => {
  const navigate = useNavigate();

  const filterOrders = orders.splited.filter((order) =>
    selectedItems.splitId.includes(order.split_id)
  );

  const hasGeneratedInvoice = filterOrders.every(
    (order) => order?.invoice_generated === 1
  );
  console.log("====>", hasGeneratedInvoice);
  const generateInvoice =
    !hasGeneratedInvoice &&
    filterOrders.some(
      (order) => order?.dispatch_status === 1 && order?.invoice_generated !== 1
    );
  const dispatch = filterOrders.some((order) => order.dispatch_status === 0);
  const deliver = filterOrders.some(
    (order) => order.dispatch_status === 1 && order.delivered_status === 0
  );

  if (orders.splited.length <= 0) return null;

  function formatDate(inputDate) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date(inputDate);
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day} ${month} ${year}`;
  }

  return (
    <div className="flex">
      <div className="caret">
        <div className="splited-items">
          <div className="order-heading">
            <p className="order-heading-text">#Splited Orders</p>
            <div>
              {dispatch && (
                <button
                  onClick={(event) =>
                    handleButtonClick(event, orders.splited, "dispatch")
                  }
                  className="btn btn-success ml-1 deliver-css"
                >
                  Dispatch
                </button>
              )}
              {generateInvoice && !dispatch && (
                <button
                  onClick={() =>
                    setOpenMarkedGenerated({
                      orders: orders.splited,
                      selectedItems,
                    })
                  }
                  className="btn btn-success ml-1"
                >
                  Marked as Generated
                </button>
              )}

              {generateInvoice && !dispatch && (
                <button
                  onClick={() =>
                    genrateInvoiceModal({
                      orders: orders.splited,
                      selectedItems,
                    })
                  }
                  className="btn btn-default btn-sm ml-1 download-invoice"
                >
                  Generate Invoice
                </button>
              )}

              {deliver && (
                <button
                  onClick={(event) =>
                    handleButtonClick(event, orders.splited, "deliver")
                  }
                  className="btn btn-success ml-1 deliver-css"
                >
                  Delivered
                </button>
              )}
            </div>
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order No</th>
                  <th>Dealer Name</th>
                  <th>Order Date</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {orders.splited.map((singleOrder, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        onChange={(event) =>
                          selectItems(
                            event,
                            singleOrder.split_id,
                            location,
                            singleOrder.order_id,
                            "split"
                          )
                        }
                        className="select-merge"
                        disabled={singleOrder.invoice_generated === 1}
                        checked={selectedItems.splitId.includes(
                          singleOrder.split_id
                        )}
                      />
                    </td>
                    <td>
                      <Link
                        to={`/admin/dispatch/view/${singleOrder.split_id}/${singleOrder.order_id}`}
                      >
                        #{singleOrder.order_no}
                      </Link>
                    </td>
                    <td>{singleOrder.name}</td>
                    <td>{formatDate(singleOrder.order_date)}</td>
                    <td>
                      {singleOrder.dispatch_status === 0 && (
                        <span className="tag tag-warning">Pending</span>
                      )}
                      {singleOrder.dispatch_status === 1 &&
                        singleOrder.delivered_status === 0 && (
                          <span
                            className="tag tag-success"
                            style={{ background: "#e08b3d", color: "white" }}
                          >
                            Dispatched
                          </span>
                        )}
                      {singleOrder.dispatch_status === 1 &&
                        singleOrder.delivered_status === 1 && (
                          <span
                            className="tag tag-default"
                            style={{ background: "#50ae31", color: "white" }}
                          >
                            Delivered
                          </span>
                        )}
                    </td>
                    <td style={{ minWidth: "260px" }}>
                      {singleOrder.dispatch_status === 0 && (
                        <button
                          className="btn btn-success ml-1"
                          onClick={() =>
                            navigate(
                              `/admin/dispatch/edit/${
                                singleOrder.split_id
                              }/${null}`
                            )
                          }
                        >
                          Transporter
                        </button>
                      )}
                      {singleOrder.invoice_generated === 1 &&
                        singleOrder.delivered_status !== 1 && (
                          <button
                            className="btn btn-success ml-1"
                            onClick={(e) =>
                              handleDeliverButton(
                                e,
                                singleOrder.order_id,
                                singleOrder.split_id
                              )
                            }
                          >
                            Delivered
                          </button>
                        )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplitedOrders;
